var map = {
	"./App": 3058,
	"./App.vue": 3058,
	"./assets/website-04/data": 4259,
	"./assets/website-04/data.json": 4259,
	"./assets/website-04/favicon.png": 6384,
	"./assets/website-04/favicon.webp": 9355,
	"./assets/website-04/images/audemars-01.webp": 4158,
	"./assets/website-04/images/audemars-02.webp": 7832,
	"./assets/website-04/images/audemars-03.webp": 6286,
	"./assets/website-04/images/audemars-04.webp": 4608,
	"./assets/website-04/images/audemars-400.webp": 4804,
	"./assets/website-04/images/banner-02.webp": 4370,
	"./assets/website-04/images/banner-05.webp": 3028,
	"./assets/website-04/images/logo-00.webp": 3187,
	"./assets/website-04/images/logo-01.webp": 4786,
	"./assets/website-04/images/logo.webp": 4029,
	"./assets/website-04/images/mision-00.webp": 6028,
	"./assets/website-04/images/patek-01.webp": 8555,
	"./assets/website-04/images/patek-02.webp": 4164,
	"./assets/website-04/images/patek-03.webp": 9161,
	"./assets/website-04/images/patek-04.webp": 1865,
	"./assets/website-04/images/patek-p3-removebg-preview.webp": 3864,
	"./assets/website-04/images/patek-philippe-400.webp": 1158,
	"./assets/website-04/images/rolex-1.webp": 4314,
	"./assets/website-04/images/rolex-2.webp": 925,
	"./assets/website-04/images/rolex-3.webp": 3390,
	"./assets/website-04/images/rolex-4.webp": 1857,
	"./assets/website-04/images/rolex-400.webp": 291,
	"./components/FooterComponent": 6794,
	"./components/FooterComponent.vue": 6794,
	"./components/ItemComponent": 9173,
	"./components/ItemComponent.vue": 9173,
	"./components/ItemImageTapeComponent": 9297,
	"./components/ItemImageTapeComponent.vue": 9297,
	"./components/ItemImagesComponent": 9162,
	"./components/ItemImagesComponent.vue": 9162,
	"./components/ItemListComponent": 4905,
	"./components/ItemListComponent.vue": 4905,
	"./components/ItemOnlyTextComponent": 9276,
	"./components/ItemOnlyTextComponent.vue": 9276,
	"./components/ItemPricingComponent": 4761,
	"./components/ItemPricingComponent.vue": 4761,
	"./components/ItemSectionComponent": 1793,
	"./components/ItemSectionComponent.vue": 1793,
	"./components/ItemSwiperComponent": 6642,
	"./components/ItemSwiperComponent.vue": 6642,
	"./components/ListComponent": 3838,
	"./components/ListComponent.vue": 3838,
	"./components/LoadImageComponent": 9922,
	"./components/LoadImageComponent.vue": 9922,
	"./components/MainBannerComponent": 5269,
	"./components/MainBannerComponent.vue": 5269,
	"./components/NavbarComponent": 9564,
	"./components/NavbarComponent.vue": 9564,
	"./components/PopupComponent": 2019,
	"./components/PopupComponent.vue": 2019,
	"./main": 866,
	"./main.js": 866,
	"./services/DataWebsite": 5467,
	"./services/DataWebsite.js": 5467,
	"./services/getCurrentDateTime": 2800,
	"./services/getCurrentDateTime.js": 2800,
	"./services/googleSchemeGenerator": 4241,
	"./services/googleSchemeGenerator.js": 4241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;